<template>
	<div>

    <v-dialog v-if="showPriceCheck">
      <v-price-check
        :reservation="reservation"
        @click="showPriceCheck = false"
        @updatePrice="updatePrice">
      </v-price-check>
    </v-dialog>

    <v-delete-dialog
      v-if="showingAlert"
      @close="showingAlert = false"
      @confirm="onRemoveOrder"
      @cancel="cancelDelete"
      :errorMessage="errorMessage">
    </v-delete-dialog>

    <d-container fluid class="main-content-container px-4" v-if="order !== null">
      <div class="page-header row no-gutters py-4 d-flex justify-content-between">
        <div class="col-12 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">Order</span>
          <h3 class="page-title">{{order.firstName}} {{order.lastName}} - ref: {{order.reference}}</h3>
        </div>
      </div>

      <d-row class="mb-4">
        <d-col lg="12">
          <d-card class="card-small">

              <d-card-header class="d-flex justify-content-between">
                <h6 class="m-0 align-self-center">Reservation Details</h6>
                <div>
                  <d-dropdown size="sm" text="actions" right>
                    <d-dropdown-item >
                      <div @click="onEditable" class="d-flex">
                        <i class="fa fa-edit align-self-center"></i>
                        <div>edit reservation</div>
                      </div>
                    </d-dropdown-item >
                    <div class="dropdown-divider"></div>
                    <d-dropdown-item >
                      <div @click="onSendConfirmation" class="d-flex">
                        <i class="fa fa-paper-plane align-self-center"></i>
                        <div>send confirmation email</div>
                      </div>
                    </d-dropdown-item>
                    <d-dropdown-item v-if="order.voucher !== null">
                      <div @click="onDownloadVoucher" class="d-flex">
                        <i class="fa fa-download align-self-center"></i>
                        <div>download voucher</div>
                      </div>
                    </d-dropdown-item>
                    <d-dropdown-item >
                      <div @click="onCheckPrice" class="d-flex">
                        <i class="fa fa-euro-sign align-self-center"></i>
                        <div>check price</div>
                      </div>
                    </d-dropdown-item>
                    <div class="dropdown-divider"></div>
                    <d-dropdown-item >
                      <div @click="confirmDelete" class="d-flex">
                        <i class="fa fa-trash align-self-center" style="width: 20px"></i>
                        <div >cancel reservation</div>
                      </div>
                    </d-dropdown-item >
                  </d-dropdown>
                </div>

              </d-card-header>

              <d-card-body>

                <d-form >

                  <d-row class="mb-4">
                    <d-col lg="6" class="flex-column">

                      <d-row class="d-flex mb-2">
                        <d-col lg="3" class="align-self-center">Price:</d-col>
                        <d-col lg="2">
                          <d-input-group prepend="€">
                            <d-form-input disabled v-model="order.price.amount" type="text" />
                          </d-input-group>
                        </d-col>
                      </d-row>
                      <d-row class="d-flex mb-2">
                        <d-col lg="3" class="align-self-center">Ordered at:</d-col>
                        <d-col lg="4">
                          <d-form-input disabled v-model="d_createdAt" type="text" />
                        </d-col>
                        <d-col lg="4">
                          <d-form-input disabled v-model="t_createdAt" type="text" />
                        </d-col>
                      </d-row>


                    </d-col>
                    <d-col lg="6" class="flex-column">

                      <d-row class="d-flex mb-2">
                        <d-col lg="3" class="align-self-center">Status:</d-col>
                        <d-col lg="8" >
                          <d-badge class="mt-2 mb-2" :class="showStatusFeedback(order.status)">{{order.status}}</d-badge>
                        </d-col>
                      </d-row>
                      <d-row class="d-flex mb-2">
                        <d-col lg="3" class="align-self-center">Language:</d-col>
                        <d-col lg="8" >
                            <d-form-input disabled :value="(order.language.toUpperCase())" type="text" />
                        </d-col>
                      </d-row>



                    </d-col>
                  </d-row>

                  <d-row lg="12" class="mb-2">
                    <d-col>
                      <h6>Costumer details</h6>
                      <hr>
                    </d-col>
                  </d-row>

                    <d-row class="mb-4">
                      <d-col>
                        <d-row class="d-flex mb-2">
                          <d-col lg="3" class="align-self-center">Name:</d-col>
                          <d-col lg="8">
                            <d-form-input disabled :value="(order.firstName + ' ' + order.lastName)" type="text" />
                          </d-col>
                        </d-row>

                        <d-row class="d-flex mb-2">
                          <d-col lg="3" class="align-self-center">Email:</d-col>
                          <d-col lg="8">
                            <d-form-input :disabled="!editable" v-model="order.email" type="email" />
                          </d-col>
                        </d-row>
                      </d-col>
                      <d-col>
                        <d-row class="d-flex mb-2">
                          <d-col lg="3" class="align-self-center">Phone:</d-col>
                          <d-col lg="8">
                            <d-form-input :disabled="!editable" v-model="order.phone" type="text" />
                          </d-col>
                        </d-row>

                        <d-row class="d-flex mb-2">
                          <d-col lg="3" class="align-self-center">Voucher:</d-col>
                          <d-col lg="8">
                            <a v-if="order.voucher !== null" :href="order.voucher.url"><i class="fa fa-download mr-2 mt-2 mb-2"></i></a>
                            <span v-else> -- </span>
                          </d-col>
                        </d-row>
                      </d-col>
                    </d-row>

                  <template v-if="order.service.provider !== null">

                    <d-row lg="12" class="mb-2">
                      <d-col>
                        <h6>Provider details</h6>
                        <hr>
                      </d-col>
                    </d-row>

                    <d-row class="mb-4">

                      <d-col lg="6" class="flex-column">
                        <d-row class="d-flex mb-2">
                          <d-col lg="3" class="align-self-center">Provider:</d-col>
                          <d-col lg="8">
                            <d-form-input disabled v-model="order.service.provider.name" type="text" />
                          </d-col>
                        </d-row>

                        <d-row class="d-flex mb-2">
                          <d-col lg="3" class="align-self-center">Location:</d-col>
                          <d-col lg="8">
                            <d-form-input disabled v-model="order.service.provider.location.address.city" type="text" />
                          </d-col>
                        </d-row>
                      </d-col>

                      <d-col lg="6" class="flex-column">
                        <d-row class="d-flex mb-2">
                          <d-col lg="3" class="align-self-center">Parking Type:</d-col>
                          <d-col lg="8">
                            <d-form-input disabled v-model="order.service.type.localizedName" type="text" />
                          </d-col>
                        </d-row>

                        <d-row class="d-flex mb-2">
                          <d-col lg="3" class="align-self-center">Covered:</d-col>
                          <d-col lg="8" class="d-flex ">
                            <d-form-checkbox class="mt-1 mb-1" disabled v-model="!order.regular"></d-form-checkbox>
                          </d-col>
                        </d-row>
                      </d-col>

                    </d-row>

                  </template>
                  <template v-if="order.service.mobian !== null">

                    <d-row lg="12" class="mb-2">
                      <d-col>
                        <h6>Mobian details</h6>
                        <hr>
                      </d-col>
                    </d-row>

                    <d-row class="mb-4">

                      <d-col lg="6" class="flex-column">
                        <d-row class="d-flex mb-2">
                          <d-col lg="3" class="align-self-center">Mobian Product:</d-col>
                          <d-col lg="8">
                            <d-form-input disabled v-model="order.service.mobian.name" type="text" />
                          </d-col>
                        </d-row>

                        <d-row class="d-flex mb-2">
                          <d-col lg="3" class="align-self-center">Mobian Order ID:</d-col>
                          <d-col lg="8">
                            <d-form-input disabled v-model="order.mobianID" type="text" />
                          </d-col>
                        </d-row>
                      </d-col>

                      <d-col lg="6" class="flex-column">
                        <d-row class="d-flex mb-2">
                          <d-col lg="3" class="align-self-center">Parking Type:</d-col>
                          <d-col lg="8">
                            <d-form-input disabled v-model="order.service.type.localizedName" type="text" />
                          </d-col>
                        </d-row>

                        <d-row class="d-flex mb-2">
                          <d-col lg="3" class="align-self-center">Covered:</d-col>
                          <d-col lg="8" class="d-flex ">
                            <d-form-checkbox class="mt-1 mb-1" disabled v-model="!order.regular"></d-form-checkbox>
                          </d-col>
                        </d-row>
                      </d-col>

                    </d-row>

                  </template>

                  <d-row lg="12" class="mb-2">
                    <d-col>
                      <h6>Car details</h6>
                      <hr>
                    </d-col>
                  </d-row>

                  <d-row class="mb-4">

                    <d-col lg="6" class="flex-column">
                      <d-row class="d-flex mb-2">
                        <d-col lg="3" class="align-self-center">License plate:</d-col>
                        <d-col lg="8">
                          <d-form-input :disabled="!editable" v-model="order.licensePlate" type="text" />
                        </d-col>
                      </d-row>
                    </d-col>

                    <d-col lg="6" class="flex-column">
                    </d-col>

                  </d-row>

                  <d-row lg="12">
                    <d-col>
                      <h6>Flight details</h6>
                      <hr>
                    </d-col>
                  </d-row>

                  <d-row>
                    <d-col lg="6" class="flex-column">

                      <d-row class="d-flex mb-2">
                        <d-col lg="3" class="align-self-center">Departure flight no:</d-col>
                        <d-col lg="8">
                          <d-form-input :disabled="!editable" v-model="order.departureFlightNumber" type="text" />
                        </d-col>
                      </d-row>

                      <d-row class="d-flex mb-2">
                        <d-col lg="3" class="align-self-center">Departure:</d-col>
                        <d-col lg="4">
                          <d-input-group prepend="Date">
                            <d-form-input :disabled="!editable" v-model="d_fromDate" type="date" />
                          </d-input-group>
                        </d-col>
                        <d-col lg="4">
                          <d-input-group prepend="Time">
                            <d-form-input :disabled="!editable" v-model="d_fromTime" type="time" />
                          </d-input-group>
                        </d-col>
                      </d-row>

                    </d-col>

                    <d-col lg="6" class="flex-column">

                      <d-row class="d-flex mb-2">
                        <d-col lg="3" class="align-self-center">Arrival flight no:</d-col>
                        <d-col lg="8">
                          <d-form-input :disabled="!editable" v-model="order.arrivalFlightNumber" type="text" />
                        </d-col>
                      </d-row>

                      <d-row class="d-flex mb-2">
                        <d-col lg="3" class="align-self-center">Arrival:</d-col>
                        <d-col lg="4">
                          <d-input-group prepend="Date">
                            <d-form-input :disabled="!editable" v-model="d_toDate" type="date" />
                          </d-input-group>
                        </d-col>
                        <d-col lg="4">
                          <d-input-group prepend="Time">
                            <d-form-input :disabled="!editable" v-model="d_toTime" type="time" />
                          </d-input-group>
                        </d-col>
                      </d-row>

                    </d-col>

                  </d-row>

                  <d-row class="mt-2">
                    <d-col class="col-lg-12">
                      <v-feedback :bus="bus"></v-feedback>
                    </d-col>
                  </d-row>

                </d-form>

              </d-card-body>

              <d-card-footer class="d-flex justify-content-between" v-if="editable">
                <d-button size="sm" class="button" @click="onCancel">Cancel</d-button>
                <d-button size="sm" class="button" @click="onSubmit">Save</d-button>
              </d-card-footer>

          </d-card>
        </d-col>
      </d-row>

      <v-payments :payments="payments"></v-payments>

    </d-container>
  </div>
</template>

<script>
	import Vue from "vue";

  export default {
		name: "OrderDetail",

    data: function () {
      return {
        payments:null,
        showPriceCheck: false,
        showIsDirty: false,
        order: null,
        editable: false,
        showingAlert: false,
        bus: new Vue(),
        errorMessage: 'Do you really want to cancel this order?',
        reservation: null,
        d_toDate: null,
        d_toTime: null,
        d_fromDate: null,
        d_fromTime: null,
        d_createdAt:null,
        t_createdAt:null
      }
    },

    apollo: {
      load: function () {
        return {
          fetchPolicy: 'no-cache',
          variables: {
            id: this.$route.params.id,
          },
          update: function (data) {

            this.order = data.order;
            this.d_fromDate = this.reformatDate(this.order.from)
            this.d_fromTime = this.reformatTime(this.order.from)
            this.d_toDate = this.reformatDate(this.order.to)
            this.d_toTime = this.reformatTime(this.order.to)
            this.d_createdAt = this.reformatDate(this.order.createdAt)
            this.t_createdAt = this.reformatTime(this.order.createdAt)

            this.payments = data.order.payments;

            this.reservation = {
              orderId: this.$route.params.id,
              providerID: (this.order.service.providerID !== null) ? this.order.service.providerID : '',
              providerLocation: (this.order.service.provider !== null) ? this.order.service.provider.location.address.city : '',
              providerName: (this.order.service.provider !== null) ? this.order.service.provider.name : '',
              providerLogoURL: '',
              startDate: this.d_fromDate,
              startTime: this.d_fromTime,
              endDate: this.d_toDate,
              endTime: this.d_toTime,
              orderPrice: this.order.price.amount,
              newPrice: '0.00',
// this was not in used and caused the dashboard to malfunction since the data is not available on gateway. commented out
//              serviceType: (this.order.service.type !== null) ? this.order.service.type.localizedName : '',
            }

            if (this.order.service.pages !== null) {
              this.order.service.pages.map(item => {
                if(item.regularService !== null && this.order.service.id === item.regularService.id) {
                  this.order.regular = this.reservation.regular = true;
                }
                if(item.coveredService !== null && this.order.service.id === item.coveredService.id) {
                  this.order.regular = this.reservation.regular = false;
                }
              })
            }
          },
          query: require('../../graphql/orders/GetOrder.gql'),
        };
      },
    },

    methods: {

		  onEditable: function() {
		    this.editable = true
      },



      onCheckPrice: function($event) {
        this.showPriceCheck = true
      },

      confirmDelete: function() {
        this.showingAlert = true;
      },

      onDownloadVoucher: function() {
        window.location.href = this.order.voucher.url;
      },

      onSendConfirmation: async function() {
        const variables = {
          id: this.order.id
        };

        try {
          const data = await this.$apollo.query({
            query: require('../../graphql/orders/SendConfirmationOrder.gql'), variables, fetchPolicy: 'no-cache'
          }).then(data => {
            if (!data.data.sendConfirmation.success) {
              this.bus.$emit('submitData', {type: 'warning', message: 'Error: No confirmation email has been sent!'})
            } else {
              this.bus.$emit('submitData', {type: 'success', message: 'The confirmationemail has been sent to: ' + this.order.email})
            }
          })
        } catch (error) {
          // Todo: show feedback
          this.bus.$emit('submitData', {type: 'warning', message: 'Error: ' + this.errors[0].message})
        }
      },

      onRemoveOrder: async function() {

        this.showingAlert = false;

        const variables = {
          id: this.order.id
        };

        try {
          const data = await this.$apollo.query({
            query: require('../../graphql/orders/CancelOrder.gql'), variables, fetchPolicy: 'no-cache'
          }).then(data => {
            if (!data.data.cancelOrder.success) {
              this.bus.$emit('submitData', {type: 'warning', message: 'Error: reservation has not been removed!'})
            } else {
              this.$router.push({
                name: 'orders.overview',
              });
            }
          })
        } catch (error) {
          // Todo: show feedback
          this.bus.$emit('submitData', {type: 'warning', message: 'Error: ' + this.errors[0].message})
        }
      },

      cancelDelete() {
        this.showingAlert = false;
      },

		  showStatusFeedback: function(status) {
        let theme = 'badge mr-1 ';
        if (status.toLowerCase() === 'pending') {
          theme = 'badge-warning';
        } else if (status.toLowerCase() === 'completed') {
          theme = 'badge-success';
        } else if (status.toLowerCase() === 'cancelled') {
          theme = 'badge-danger';
        } else if (status.toLowerCase()=== 'undetermined') {
          theme = 'badge-primary';
        }
        return theme;
      },

      reformatDate: function(date) {

        let year =  new Date(date).getFullYear()
        let month =  new Date(date).getMonth()+1
        if (month < 10)  month = '0' + month;
        let day = new Date(date).getDate()
        if (day < 10)  day = '0' + day;

        let correctedDate = year + "-" + month+ "-" + day
        return correctedDate
      },

      reformatTime: function(date) {

        let d = new Date(date)
        var options = { hour12: false, hour: '2-digit', minute: '2-digit'  };
        let formatedTime = d.toLocaleTimeString("en-US", options)
        return formatedTime
      },

      createDateWithoutTimezone: function (date, time) {
        let convertedDate = new Date( date + "T" + time + ":00").toISOString()
        return convertedDate
      },

      onCancel:function() {
        this.editable = false;
      },

      updatePrice: function(evt) {
        this.showPriceCheck = false
        this.d_fromDate = evt.from;
        this.d_fromTime = evt.fromTime;
        this.d_toDate = evt.to;
        this.d_toTime = evt.toTime;

        this.onSubmit()
      },

      onSubmit: async function () {

        let  mutation = require('../../graphql/orders/UpdateOrder.gql')

        let from = this.createDateWithoutTimezone(this.d_fromDate, this.d_fromTime)
        let to = this.createDateWithoutTimezone(this.d_toDate, this.d_toTime)


        // Add default variables for creating and updating
        let variables = {
          id: this.order.id,
          email: this.order.email,
          phone: this.order.phone,
          licensePlate: this.order.licensePlate,
          departureFlightNumber: this.order.departureFlightNumber,
          arrivalFlightNumber: this.order.arrivalFlightNumber,
          from,
          to
        };

        try {
          const data = await this.$apollo.mutate({mutation, variables, fetchPolicy: 'no-cache'})
            .then(data => {
              if (!data.data.updateOrder.success) {
                this.bus.$emit('submitData', {type: 'warning', message: 'Error: reservation has not been updated!'})
              } else {
                window.location.reload(true)
              }
            })
        } catch (error) {
          // Todo: show feedback
          this.bus.$emit('submitData', {type: 'warning', message: 'Error: ' + this.errors[0].message})
        }
      }
    }
	}


</script>
